import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EuiFooterComponent } from './footer.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiFooterComponent,
    ],
    exports: [
        EuiFooterComponent,
    ],
})
export class EuiFooterModule { }
